import { render } from "./ApprovalsManager.vue?vue&type=template&id=62aaefc2&scoped=true"
import script from "./ApprovalsManager.vue?vue&type=script&lang=js"
export * from "./ApprovalsManager.vue?vue&type=script&lang=js"

import "./ApprovalsManager.vue?vue&type=style&index=0&id=62aaefc2&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aaefc2"]])

export default __exports__